import React, { useEffect } from "react";
import EditBusiness from "./EditBusiness.js";
import Axios from "axios";
import TableBusiness from "./TableBusiness";
import { Switch, Route, useRouteMatch, withRouter } from "react-router-dom";
import {
  businessParserFromServer,
  businessParserToServer,
  setBusinessInitState,
} from "./Helper";
import { businessErrors } from "../../consts/ErrorMessages.js";
import * as Constants from "../../consts/Constants.js";
import { isValidPhoneNumber } from "../../utils/StringUtils.js";

import "../../styles/css/App.css";

function Business({ history }) {
  let { path, url } = useRouteMatch();
  let location = {};

  const handleClickOpen = (event, rowData) => {
    if (rowData !== undefined) {
      let data = "";
      Axios.get(Constants.FINAL_URL_BUSINESS + rowData.id).then((response) => {
        data = response.data;
        setInputsForm(businessParserFromServer(data));
        history.push(`${url}/form`);
      });
    } else {
      setInputsForm(setBusinessInitState());
      history.push(`${url}/form`);
    }
  };

  const handleDelete = (rowData) => {
    Axios.delete(Constants.FINAL_URL_BUSINESS + rowData.id).then((response) => {
      getBusiness();
    });
  };

  const handleClose = () => {
    handleCleaner();
    history.goBack();
  };

  const saveNewBusiness = () => {
    let url = Constants.FINAL_URL_BUSINESS;
    let business = businessParserToServer({
      ...inputsForm,
      location: location,
    });
    Axios.post(url, business)
      .then((response) => {
        handleClose();
        getBusiness();
      })
      .catch((response) => {});
  };

  const saveEditBusiness = () => {
    let url = Constants.FINAL_URL_BUSINESS + inputsForm.id;
    let business = businessParserToServer({
      ...inputsForm,
      location: location,
    });
    Axios.put(url, business)
      .then((response) => {
        handleClose();
        getBusiness();
      })
      .catch((response) => {});
  };

  const save = () => {
    if (validateForm())
      inputsForm.id !== undefined ? saveEditBusiness() : saveNewBusiness();
  };

  const [errors, setErrors] = React.useState({});

  const isValidLocation = (location) => {
    if (!location.match(/^[-]?\d+[\.]?\d*, [-]?\d+[\.]?\d*$/)) {
      return false;
    }
    const [latitude, longitude] = location.split(",");
    return (
      latitude > -90 && latitude < 90 && longitude > -180 && longitude < 180
    );
  };

  const isValidTime = (time) => {
    if (!time.match(/^(0[0-9]|1[0-9]|2[0-4]):[0-5][0-9]$/)) {
      return false;
    }
    const [hora, minutos] = time.split(":");
    return hora >= 0 && hora <= 24 && minutos >= 0 && minutos < 60;
  };

  const isValidPhoneNumbers = (phoneNumbers) => {
    let numbers = phoneNumbers.split(",");
    for (var i = 0; i < numbers.length; i++)
      if (!isValidPhoneNumber(numbers[i])) return false;
    return true;
  };

  const isValidSchedule = () => {
    let errors = 0;
    inputsForm.schedule.forEach((r) => {
      if (r.startTime !== "" && !isValidTime(r.startTime)) errors++;
      if (r.endTime !== "" && !isValidTime(r.endTime)) errors++;
    });
    return errors === 0;
  };

  const validateForm = () => {
    let name = false;
    let address = false;
    let keywords = false;
    let phoneNumbers = false;
    let delivery = false;
    let location = false;
    let whatsApp = false;
    let category = false;
    let ownerDni = false;
    let schedule = false;

    if (inputsForm.name.length === 0) {
      name = true;
    }
    if (inputsForm.address.length === 0) {
      address = true;
    }
    if (inputsForm.keywords.length === 0) {
      keywords = true;
    }
    if (
      inputsForm.phoneNumbers.length === 0 ||
      !isValidPhoneNumbers(inputsForm.phoneNumbers)
    ) {
      phoneNumbers = true;
    }
    if (inputsForm.whatsApp.length > 0) {
      if (!isValidPhoneNumbers(inputsForm.whatsApp)) {
        whatsApp = true;
      }
    }
    if (inputsForm.delivery.length === 0) {
      delivery = true;
    }

    if (inputsForm.category.length === 0) {
      category = true;
    }
    if (inputsForm.ownerDni.length === 0) {
      ownerDni = true;
    }
    if (!isValidSchedule()) schedule = true;

    setErrors({
      ...errors,
      name,
      address,
      keywords,
      phoneNumbers,
      delivery,
      whatsApp,
      location,
      category,
      ownerDni,
      schedule,
    });

    if (
      name ||
      address ||
      keywords ||
      phoneNumbers ||
      delivery ||
      location ||
      category ||
      whatsApp ||
      ownerDni ||
      schedule
    )
      return false;
    return true;
  };

  const [errorsMessages, setErrorsMessages] = React.useState(businessErrors);

  //Entradas tabla
  const [entries, setEntries] = React.useState({
    data: [],
  });

  //Entradas formulario edicion
  const [inputsForm, setInputsForm] = React.useState({});

  const handleSchedule = ({ indexDay, range, name, value }) => {
    setInputsForm({
      ...inputsForm,
      schedule: inputsForm.schedule.map((d) =>
        d.day === indexDay && d.range === range ? { ...d, [name]: value } : d
      ),
    });
  };

  const handleLocation = (newLocation) => {
    location = newLocation;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputsForm({ ...inputsForm, [name]: value });
  };

  const handleCleaner = (e) => {
    setInputsForm(setBusinessInitState());
    setErrors({});
  };

  const getBusiness = () => {
    let source = Axios.CancelToken.source();
    Axios.get(Constants.FINAL_URL_BUSINESS, {
      cancelToken: source.token,
    })
      .then((response) => {
        let data = [];
        response.data.forEach((businessItem) => {
          data.push(businessItem);
        });
        setEntries({ data: data });
      })
      .catch(function (thrown) {});
    return () => source.cancel();
  };
  useEffect(() => {
    getBusiness();
  }, []);

  return (
    <Switch>
      <Route exact path={path}>
        <TableBusiness
          {...{
            handleClickOpen,
            handleDelete,
            entries,
          }}
        />
      </Route>
      <Route exact path={`${path}/form`}>
        <EditBusiness
          {...{
            handleClose,
            handleChange,
            handleLocation,
            handleSchedule,
            save,
            inputsForm,
            errors,
            setErrors,
            errorsMessages,
          }}
        />
      </Route>
    </Switch>
  );
}

export default withRouter(Business);
